import { SELECT_LEAD } from "redux/action-types/SelectLead";

export const selectLead = (payload) => ({
    type: SELECT_LEAD,
    payload,
});